module.exports = __webpack_public_path__ + "static/img/06.e9dacef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/06.jpg
// module id = oEPo
// module chunks = 0